export type Stage = 'production' | 'dev' | 'test'

function isValidStage(value: string | null | undefined): value is Stage {
  return !!value && ['dev', 'test', 'production'].includes(value)
}

export function getStageFromDeployEnvironment(): Stage {
  const environment = process.env.DEPLOY_ENVIRONMENT
  if (!environment) {
    throw new Error(`DEPLOY_ENVIRONMENT env var is not defined`)
  }
  const stage = environment.toLowerCase().substring(environment.lastIndexOf('-') + 1)
  if (!isValidStage(stage)) {
    throw new Error(`DEPLOY_ENVIRONMENT env var is not valid`)
  }
  return stage
}

/**
 * @deprecated Use `getStageFromDeployEnvironment` instead
 *
 * This is here as a utility to mimic the old `getDeployEnvironment()` function from our utilities package.
 * This function defaults to 'dev' if no environment variable is set. This is not intended
 */
export function getStageFromDeployEnvironmentLegacy(): Stage {
  try {
    return getStageFromDeployEnvironment()
  } catch {
    return 'dev'
  }
}
